import {tryParse} from 'jsurl2'

export default hooks => {
	hooks.render.initRenderContext.tap('react-ssr', context => {
		context.state = tryParse(globalThis.__INITIAL_STATE__, {})
		// Save some memory
		if (!import.meta.hot) delete globalThis.__INITIAL_STATE__
	})
}
